<template>
	<div>
		<div>
			<SalaryEdit
				v-model="salary"
				:inline="false"
				@input="emitChangeEvent"
			>
				<template #input-info>
					<div>Dein Mindestgehalt - pro Monat - <b>Brutto</b> vor Abzug der Steuern.</div>
					<div v-if="isPartTime">Bei Teilzeit bitte auf Basis von Vollzeit eingeben - das ist wichtig für
						das Matching.
					</div>
					<div>Jobs mit höherem Gehalt werden angezeigt!</div>
				</template>
			</SalaryEdit>
		</div>
		<JonInfo>
			<template #message>
				Deine genaue Gehaltsangabe wird ArbeitgeberInnen nicht angezeigt, sondern dient nur dem Matching bzw.
				dem Ermitteln, ob ein Job passt.
			</template>
		</JonInfo>
	</div>
</template>

<script>
import SalaryEdit from "@/vue/common/salary/Edit";
import {isDefined} from "@/helper/Value";
import {EMPLOYED_PART} from "@/helper/application/characteristic/EmploymentMode";
import InfoBox from "@/vue/common/InfoBox.vue";
import _ from "lodash";
import JonInfo from "@/vue/common/JonInfo";

export default {

	components: {
		JonInfo,
		InfoBox,
		SalaryEdit,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		employmentModes: {
			type: Array,
			required: true,
		},
	},

	data ()
	{
		return {
			salary: this.value ? {
				salary: this.value.salary,
				salaryMax: this.value.salaryMax,
				base: this.value.salaryBase,
			} : null
		};
	},

	computed: {
		isPartTime ()
		{
			return isDefined(
				_.find(this.employmentModes, characteristic => characteristic.naturalId === EMPLOYED_PART)
			);
		},
		dataValid ()
		{
			return isDefined(this.salary);
		}
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				salary: this.salary.salary
			});
		},
	},
}
</script>
